import { render } from "./Token.vue?vue&type=template&id=78e980e4&scoped=true&ts=true"
import script from "./Token.vue?vue&type=script&lang=ts"
export * from "./Token.vue?vue&type=script&lang=ts"

import "./Token.vue?vue&type=style&index=0&id=78e980e4&scoped=true&lang=scss"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e980e4"]])

export default __exports__